import { Alert, Col, Container, Image, Row } from 'react-bootstrap'
import { BsCalendar, BsCardText } from "react-icons/bs";
import { MdPermContactCalendar } from "react-icons/md";
import React, { useContext, useState } from 'react';
import { authContext } from '../context/AuthContext';
import { NavLink, Route, Switch, useRouteMatch } from 'react-router-dom';
import Statics from '../components/Statics';
import DoctorIndex from './DoctorIndex';
import {ReactComponent as  IconDoctor} from '../img/icons/icon-doctor.svg'
import {ReactComponent as  IconPacientes} from '../img/icons/icon-paciente.svg'
import PatientIndex from './PatientIndex';
import EspecialidadesIndex from './catalogue/EspecialidadesIndex';
import CatalogosIndex from './CatalogosIndex';
import ReligionIndex from './catalogue/ReligionIndex';
import CountryIndex from './catalogue/CountryIndex';
import LanguageIndex from './catalogue/LanguageIndex';
import CuentasIndex from './catalogue/CuentasIndex';
import CompanyIndex from './catalogue/CopanyIndex';
import PartnersIndex from './catalogue/PartnersIndex';
import CreateAppointment from './CreateAppointment';
import SearchDoctor from './doctor/SearchDoctor';
import { isAdmin } from '../utils/isAdmin';
import DashboardAdmin from '../components/DashboardAdmin';
import { isOperator } from '../utils/isOperator';
import { isAdminOperation } from '../utils/isAdminOperation';
import { isPatient } from '../utils/isPatient';
import { BiCalendarEvent } from 'react-icons/bi';
import { FaArrowAltCircleLeft, FaArrowAltCircleRight, FaRegUser, FaHireAHelper } from 'react-icons/fa';
import PerfilDoctorIndex from './PerfilDoctorIndex';
import {isDoctor} from '../utils/isDoctor'
import DashboardDoctor from '../components/DashboardDoctor';
import HisorialCitas from './doctor/HisorialCitas';
import PagarServicio from './PagarServicio';
import { VscHome } from 'react-icons/vsc';
import NoMatch from '../components/NoMatch';
import CitasPaciente from './doctor/CitasPaciente';
import DoctorEditarCita from './doctor/DoctorEditarCita'
import { withTranslation } from 'react-i18next';
import { isAdminDoctor } from '../utils/isAdminDoctor';
import { SiMinutemailer } from "react-icons/si";
import CorreosIndex from './correos/CorreosIndex';
import CitasAprobacion from './operador/CitasAprobacion';
import DashboardJefeDoctor from '../components/DashboardJefeDoctor';
import UsuarioIndex from './usuarios/UsuarioIndex';
import DashboardAdminOperation from '../components/DashboardAdminOperation';
import ReportesJefeMedico from './reportes/ReportesJefeMedico';
import { getLogo } from '../utils/getLogo';
import Notifications from '../components/Notifications';
import { ToastContainer } from 'react-toastify';
import ProveedoresIndex from './catalogue/proveedores/ProveedoresIndex';
import EstadosIndex from './catalogue/estados/EstadosIndex';
import MunicipioIndex from './catalogue/municipio/MunicipioIndex';
import EstadoCivilIndex from './catalogue/estadocivil/EstadoCivilIndex';
import { AiOutlineBarChart, AiOutlineUnorderedList } from 'react-icons/ai';
import { isCalidad } from '../utils/isCalidad';
import DashboardCalidad from '../components/DashboardCalidad';
import {ReactComponent as  IconTrazabilidad} from '../img/icons/icon-trazabilidad.svg'

import '../styles/menuDropDown.css'
import 'react-toastify/dist/ReactToastify.css';
import TrazabilidadIndex from './Trazabilidad/TrazabilidadIndex';
import TipoPacienteIndex from './catalogue/TipoPacienteIndex';
import ReportesCalidad from './reportes/ReportesCalidad';
import ReportesOperador from './reportes/ReportesOperador';
import DetalleCita from './cita/DetalleCita';
import DoctorMiAgenda from './doctor/DoctorMiAgenda';
import DoctorConference from './DoctorConference';
import DoctorConferenceOndemand from './DoctorConferenceOndemand';
import { isConsultorio } from '../utils/isConsultorio'
import DoctorPacientes from './DoctorPacientes';
import EditFormPacientes from './EditFormPacientes';
import MisRespuestaUsuario from './patient/MisRespuestaUsuario';
import Trazabilidad from './Trazabilidad';
import AddPatient from './patient/AddPatient';
import RolesIndex from './roles/RolesIndex';
import TipoPlanIndex from './catalogue/TipoPlanIndex';
import VerConexionCita from './cita/VerConexionCita';
import TextoGenerico from './TextoGenerico';
import DiagnosticosIndex from './catalogue/diagnosticos/DiagnosticosIndex';
import useCompanyType from "../hook/useCompanyType";
import EncuestaIndex from './catalogue/EncuestaIndex';

function Dashboard({t}){
    const { auth, setAuthData } = useContext(authContext);
    let {path, url} = useRouteMatch();
    const [showSideNav,setShowSideNav] = useState(false) 
    const companyType = useCompanyType();   

    return (
        <>
            <div className="d-flex">
                <div className="arrow-phone d-none" onClick={e=>setShowSideNav(!showSideNav)}>
                    {showSideNav ? <FaArrowAltCircleLeft /> : <FaArrowAltCircleRight />}
                </div>
                <div className={`sidenav ${showSideNav ? 'sidenav-block' : ''}`}>
                    <NavLink to={`${url}`} activeClassName="active"><Image src={getLogo(auth.data.company)} fluid className="mh-100"/></NavLink>

                    {
                        isPatient(auth.data.role) && 
                        <ul className="list-unstyled my-4 sidenav-menu">
                            <li className="mb-3">
                                <NavLink exact to={`${url}`} activeClassName="active">
                                    <span className="d-block"><VscHome className="svg-icon" /></span>
                                    <span className="d-block text-size-08">{t('Inicio')}</span>
                                </NavLink>                        
                            </li>
                            <li className="mb-3">
                                <NavLink to={`${url}/patient/my-appointments`} activeClassName="active">
                                    <span className="d-block"><BiCalendarEvent className="svg-icon" /></span>
                                    <span className="d-block text-size-08">{t('mis_citas')}</span>
                                </NavLink>                        
                            </li>
                            <li className="mb-3">
                                <NavLink to={`${url}/misdoctores`} activeClassName="active">
                                    <span className="d-block"><IconDoctor className="svg-icon" /></span>
                                    <span className="d-block text-size-08">{t('mis_doctores')}</span>
                                </NavLink>                        
                            </li>
                            <li className="mb-3">
                                <NavLink to={`${url}/usuario/perfil`} activeClassName="active">
                                    <span className="d-block"><FaRegUser className="svg-icon" /></span>
                                    <span className="d-block text-size-08">{t('mi_perfil')}</span>
                                </NavLink>                        
                            </li>
                        </ul>                        
                    }
                    {
                        isOperator(auth.data.role) && 
                        <ul className="list-unstyled my-4 sidenav-menu">
                            <li className="mb-3">
                                <NavLink exact to={`${url}`} activeClassName="active">
                                    <span className="d-block"><VscHome className="svg-icon" /></span>
                                    <span className="d-block text-size-08">{t('Inicio')}</span>
                                </NavLink>                        
                            </li>
                            <li className="mb-3">
                                <NavLink to={`${url}/patients`} activeClassName="active">
                                    <span className="d-block"><IconPacientes className="svg-icon fill1" /></span>
                                    <span className="d-block text-size-08">{t('pacientes')}</span>
                                </NavLink>                        
                            </li>
                            <li className="mb-3">
                                <NavLink to={`${url}/citasparaaprobacion`} activeClassName="active">
                                    <span className="d-block"><BsCalendar className="svg-icon fill1" /></span>
                                    <span className="d-block text-size-08">Citas pendientes</span>
                                </NavLink>                        
                            </li>
                            <li className="mb-3">
                                <NavLink to={`${url}/reportes-operador`} activeClassName="active">
                                    <span className="d-block"><AiOutlineBarChart className="svg-icon" /></span>
                                    <span className="d-block text-size-08">Reportes</span>
                                </NavLink>                        
                            </li>
                        </ul>                        
                    }
                    {
                        isAdmin(auth.data.role) && 
                        <ul className="list-unstyled my-4 sidenav-menu">
                            <li className="mb-3">
                                <NavLink exact to={`${url}`} activeClassName="active">
                                    <span className="d-block"><VscHome className="svg-icon" /></span>
                                    <span className="d-block text-size-08">{t('Inicio')}</span>
                                </NavLink>                        
                            </li>
                            {/* <li className="mb-3">
                                <NavLink to={`${url}/horarios`} activeClassName="active">
                                    <span className="d-block"><BsClock className="svg-icon" /></span>
                                    <span className="d-block text-size-08">{t('horarios')}</span>
                                </NavLink>                        
                            </li> */}
                            <li className="mb-3">
                                <NavLink to={`${url}/correos`} activeClassName="active">
                                    <span className="d-block"><SiMinutemailer className="svg-icon" /></span>
                                    <span className="d-block text-size-08">{t('correos')}</span>
                                </NavLink>                        
                            </li>
                            {companyType === 'colombia' &&
                            <li className="mb-3">
                                <NavLink to={`${url}/textogenerico`} activeClassName="active">
                                    <span className="d-block"><BsCardText className="svg-icon" /></span>
                                    <span className="d-block text-size-08">Texto genérico</span>
                                </NavLink>                        
                            </li>}
                        </ul>                        
                    }
                    {
                        isDoctor(auth.data.role) &&
                        <ul className="list-unstyled my-4 sidenav-menu">
                            <li className="mb-3">
                                <NavLink exact to={`${url}`} activeClassName="active">
                                    <span className="d-block"><VscHome className="svg-icon"/></span>
                                    <span className="d-block text-size-08">{t('Inicio')}</span>
                                </NavLink>
                            </li>
                            <li className="mb-3">
                                <NavLink to={`${url}/doctor/mi-agenda`} activeClassName="active">
                                    <span className="d-block"><BiCalendarEvent className="svg-icon"/></span>
                                    <span className="d-block text-size-08">{t('agenda')}</span>
                                </NavLink>
                            </li>
                            <li className="mb-3">
                                <NavLink to={`${url}/doctors/patients`} activeClassName="active">
                                    <span className="d-block"><IconPacientes className="svg-icon fill1"/></span>
                                    <span className="d-block text-size-08">{t('pacientes')}</span>
                                </NavLink>
                            </li>
                            <li className="mb-3">
                                <NavLink to={`${url}/proveedor/historial-citas`} activeClassName="active">
                                    <span className="d-block"><MdPermContactCalendar className="svg-icon"/></span>
                                    <span className="d-block text-size-08">{t('historial_citas')}</span>
                                </NavLink>
                            </li>
                            <li className="mb-3">
                                <NavLink to={`${url}/perfilDoctor`} activeClassName="active">
                                    <span className="d-block"><FaRegUser className="svg-icon"/></span>
                                    <span className="d-block text-size-08">{t('mi_perfil')}</span>
                                </NavLink>
                            </li>
                            <li className="mb-3" id="idSeccionConferencia" hidden>
                                <button activeClassName="active" className='btn btn-block active'>
                                    <span className="d-block"><FaHireAHelper className="svg-icon"/></span>
                                    <span className="d-block text-size-08">{t('hi_smart_title')}</span>
                                </button>
                            </li>
                        </ul>
                    }
                    {
                        isAdminDoctor(auth.data.role) &&
                        <ul className="list-unstyled my-4 sidenav-menu">
                            <li className="mb-3">
                                <NavLink exact to={`${url}`} activeClassName="active">
                                    <span className="d-block"><VscHome className="svg-icon"/></span>
                                    <span className="d-block text-size-08">{t('Inicio')}</span>
                                </NavLink>                        
                            </li>
                            <li className="mb-3">
                                <NavLink to={`${url}/patients`} activeClassName="active">
                                    <span className="d-block"><IconPacientes className="svg-icon fill1" /></span>
                                    <span className="d-block text-size-08">{t('pacientes')}</span>
                                </NavLink>                        
                            </li>
                            <li className="mb-3">
                                <NavLink to={`${url}/doctors`} activeClassName="active">
                                    <span className="d-block"><IconDoctor className="svg-icon" /></span>
                                    <span className="d-block text-size-08">{t('doctores')}</span>
                                </NavLink>                        
                            </li>
                            <li className="mb-3">
                                <NavLink to={`${url}/reportes`} activeClassName="active">
                                    <span className="d-block"><AiOutlineBarChart className="svg-icon" /></span>
                                    <span className="d-block text-size-08">Reportes</span>
                                </NavLink>                        
                            </li>
                        </ul>                        
                    }  
                    {
                        isAdminOperation(auth.data.role) && 
                        <ul className="list-unstyled my-4 sidenav-menu">
                            <li className="mb-3">
                                <NavLink exact to={`${url}`} activeClassName="active">
                                    <span className="d-block"><VscHome className="svg-icon" /></span>
                                    <span className="d-block text-size-08">{t('Inicio')}</span>
                                </NavLink>                        
                            </li>
                            <li className="mb-3">
                                <NavLink to={`${url}/usuarios`} activeClassName="active">
                                    <span className="d-block"><IconPacientes className="svg-icon fill1" /></span>
                                    <span className="d-block text-size-08">Usuarios</span>
                                </NavLink>                        
                            </li>
                            <li className="mb-3">
                                <NavLink to={`${url}/roles`} activeClassName="active">
                                    <span className="d-block"><AiOutlineUnorderedList className="svg-icon fill1" /></span>
                                    <span className="d-block text-size-08">Roles</span>
                                </NavLink>                        
                            </li>
                        </ul>                        
                    }  
                    {
                        isCalidad(auth.data.role) && 
                        <ul className="list-unstyled my-4 sidenav-menu">
                            <li className="mb-3">
                                <NavLink exact to={`${url}`} activeClassName="active">
                                    <span className="d-block"><VscHome className="svg-icon" /></span>
                                    <span className="d-block text-size-08">{t('Inicio')}</span>
                                </NavLink>                        
                            </li>
                            <li className="mb-3">
                                <NavLink to={`${url}/trazabilidad`} activeClassName="active">
                                    <span className="d-block"><IconTrazabilidad className="svg-icon" /></span>
                                    <span className="d-block text-size-08">Trazabilidad</span>
                                </NavLink>                      
                            </li>
                            <li className="mb-3">
                                <NavLink to={`${url}/reportes-calidad`} activeClassName="active">
                                    <span className="d-block"><AiOutlineBarChart className="svg-icon" /></span>
                                    <span className="d-block text-size-08">Reportes</span>
                                </NavLink>                        
                            </li>
                        </ul>  
                    }    
                    {
                        isConsultorio(auth.data.role) && 
                        <ul className="list-unstyled my-4 sidenav-menu">
                            <li className="mb-3">
                                <NavLink exact to={`${url}`} activeClassName="active">
                                    <span className="d-block"><VscHome className="svg-icon" /></span>
                                    <span className="d-block text-size-08">{t('Inicio')}</span>
                                </NavLink>                        
                            </li>
                            <li className="mb-3">
                                <NavLink to={`${url}/doctor/mi-agenda`} activeClassName="active">
                                    <span className="d-block"><BiCalendarEvent className="svg-icon" /></span>
                                    <span className="d-block text-size-08">{t('agenda')}</span>
                                </NavLink>                        
                            </li>
                            <li className="mb-3">
                                <NavLink to={`${url}/doctors/patients`} activeClassName="active">
                                    <span className="d-block"><IconPacientes className="svg-icon fill1" /></span>
                                    <span className="d-block text-size-08">{t('pacientes')}</span>
                                </NavLink>                        
                            </li>
                            <li className="mb-3">
                                <NavLink to={`${url}/proveedor/historial-citas`} activeClassName="active">
                                    <span className="d-block"><MdPermContactCalendar className="svg-icon"/></span>
                                    <span className="d-block text-size-08">{t('historial_citas')}</span>
                                </NavLink>                        
                            </li>
                            <li className="mb-3">
                                <NavLink to={`${url}/perfilDoctor`} activeClassName="active">
                                    <span className="d-block"><FaRegUser className="svg-icon"/></span>
                                    <span className="d-block text-size-08">{t('mi_perfil')}</span>
                                </NavLink>                        
                            </li>
                            <li className="mb-3" id="idSeccionConferencia" hidden>
                                <button activeClassName="active" className='btn btn-block active'>
                                    <span className="d-block"><FaHireAHelper className="svg-icon"/></span>
                                    <span className="d-block text-size-08">{t('hi_smart_title')}</span>
                                </button>                        
                            </li>
                        </ul>                        
                    }         
                </div>

                <div className="content-wrapper d-flex flex-column">
                    <div className="content">
                        <Notifications auth={auth} setAuthData={setAuthData}/>                    
                                
                        <main>
                            {!auth.data.currentInsurance && <Row className="my-1">
                                <Col>
                                    <Alert variant="danger" className="font-weight-bold">Su poliza ha vencido. Por favor actívela para seguir usando nuestros servicios. </Alert>
                                </Col>
                            </Row>}
                            <Switch>
                                <Route exact path={`${path}`}>
                                    {
                                        isAdmin(auth.data.role) 
                                        ? <DashboardAdmin url={url}/> : 
                                        isOperator(auth.data.role) 
                                        ? <Statics /> :
                                        // isPatient(auth.data.role)  
                                        // ? <DashboardPatient url={url}/> : 
                                        (isDoctor(auth.data.role) || isConsultorio(auth.data.role)) ?
                                        <DashboardDoctor /> :
                                        isAdminOperation(auth.data.role) ? 
                                        <DashboardAdminOperation />:
                                        isCalidad(auth.data.role) ?
                                        <DashboardCalidad /> :
                                        <DashboardJefeDoctor auth={auth}/>
                                    }                                
                                </Route>

                                {/* {
                                    isPatient(auth.data.role) &&
                                    <>
                                        <Route path={`${path}/patient/agenda/:id`}><PatientAgenda url={url}/></Route>
                                        <Route path={`${path}/patient/create-appointment`}><PatientCreateAppointment url={url}/></Route>
                                        <Route path={`${path}/patient/my-appointments`}>
                                            <Container fluid className="my-5">
                                                <MisCitas imPaciente={true}/>
                                            </Container>                                        
                                        </Route>
                                        <Route path={`${path}/enconferencia/:id`}><Conference /></Route>
                                        <Route path={`${path}/usuario/perfil`}><PerfilUsuario /></Route>
                                        <Route path={`${path}/pagarservicio/:id`}><PagarServicio /></Route>
                                        <Route path={`${path}/misdoctores`}><MisDoctores /></Route>
                                        <Route path={`${path}/seleccionarhorario/:id`}><SeleccionarHorarioDoctor url={url}/></Route>
                                        <Route path={`${path}/proveedor/editar-cita/:idCita/:idDoctor/:idPaciente`}><DoctorEditarCita /></Route>
                                        <Route path={`${path}/citaemergencia/:id`}><CitaEmergencia/></Route>
                                    </>
                                } */}


                                {
                                    isOperator(auth.data.role) &&
                                    <>
                                        <Route path={`${path}/patients`}><PatientIndex /></Route>
                                        <Route path={`${path}/create-appointment/:id`}><CreateAppointment /></Route>
                                        <Route path={`${path}/pagarservicio/:id`}><PagarServicio /></Route>
                                        <Route path={`${path}/citasparaaprobacion`}><CitasAprobacion /></Route>
                                        <Route path={`${path}/reportes-operador`}><ReportesOperador /></Route>
                                        <Route path={`${path}/detalle-cita/:idParam`}><DetalleCita /></Route>
                                        <Route path={`${path}/proveedor/editar-cita/:idCita`}><DoctorEditarCita /></Route>
                                    </>
                                }


                                {
                                    isAdmin(auth.data.role) &&
                                    <>
                                        {/* <Route path={`${path}/horarios`}><HorariosIndex /></Route>  */}
                                        <Route path={`${path}/catalogos`}><CatalogosIndex /></Route>
                                        <Route path={`${path}/religiones`}><ReligionIndex /></Route>
                                        <Route path={`${path}/country`}><CountryIndex /></Route>
                                        <Route path={`${path}/language`}><LanguageIndex /></Route>                            
                                        <Route path={`${path}/cuentas`}><CuentasIndex /></Route>
                                        <Route path={`${path}/company`}><CompanyIndex /></Route>
                                        <Route path={`${path}/specialties`}><EspecialidadesIndex /></Route>
                                        <Route path={`${path}/correos`}><CorreosIndex /></Route>
                                        <Route path={`${path}/partners`}><PartnersIndex /></Route>
                                        <Route path={`${path}/proveedores`}><ProveedoresIndex /></Route>
                                        <Route path={`${path}/estados`}><EstadosIndex /></Route>
                                        <Route path={`${path}/municipios`}><MunicipioIndex /></Route>
                                        <Route path={`${path}/estadocivil`}><EstadoCivilIndex /></Route>
                                        <Route path={`${path}/tipopaciente`}><TipoPacienteIndex /></Route>
                                        <Route path={`${path}/tipoplan`}><TipoPlanIndex /></Route>
                                        <Route path={`${path}/textogenerico`}><TextoGenerico /></Route>
                                        <Route path={`${path}/diagnosticos`}><DiagnosticosIndex /></Route>
                                        <Route path={`${path}/encuesta`}><EncuestaIndex /></Route>
                                    </>
                                }


                                {
                                    isDoctor(auth.data.role) &&
                                    <>
                                        <Route path={`${path}/perfilDoctor`}><PerfilDoctorIndex /></Route>
                                        <Route path={`${path}/create-appointment/:id`}><CreateAppointment /></Route>
                                        <Route path={`${path}/doctors/patients`}><DoctorPacientes perfil="doctor" /></Route>
                                        <Route path={`${path}/doctor/patient/:id`}><EditFormPacientes /></Route>
                                        <Route path={`${path}/doctor/mi-agenda`}><DoctorMiAgenda /></Route>
                                        <Route path={`${path}/proveedor/historial-citas`}><HisorialCitas /></Route>
                                        <Route path={`${path}/proveedor/conferencia/:idParam`}><DoctorConference /></Route>
                                        <Route path={`${path}/proveedor/citas/:idDoctor/:idPaciente`}><CitasPaciente/></Route>
                                        <Route path={`${path}/proveedor/editar-cita/:idCita`}><DoctorEditarCita /></Route>
                                        <Route path={`${path}/proveedor/citacliente/:idParam`}><DoctorConferenceOndemand /></Route>
                                        <Route exact path={`/admin/patients/misrespuestas/:id`}>
                                            <Container fluid className="my-5">
                                                <MisRespuestaUsuario />
                                            </Container>
                                        </Route>
                                        <Route exact path={`/admin/patients/trazabilidad/:id`}>
                                            <Container fluid className="my-5">
                                                <Trazabilidad paciente={true}/>
                                            </Container>                                            
                                        </Route>
                                        <Route exact path={`/admin/patients/create`}>
                                            <Container fluid className="my-5">
                                                <AddPatient/>
                                            </Container>
                                        </Route>
                                    </>
                                }

                                {
                                    isAdminDoctor(auth.data.role) &&
                                    <>
                                        <Route path={`${path}/doctors`}><DoctorIndex /></Route>
                                        <Route path={`${path}/patients`}><PatientIndex /></Route>
                                        <Route path={`${path}/create-appointment/:id`}><CreateAppointment /></Route>
                                        <Route path={`${path}/reportes`}><ReportesJefeMedico /></Route>
                                        <Route path={`${path}/detalle-cita/:idParam`}><DetalleCita /></Route>
                                        <Route path={`${path}/proveedor/editar-cita/:idCita`}><DoctorEditarCita /></Route>
                                        
                                        <Route path={`${path}/verconexion-cita/:idParam`}><VerConexionCita /></Route>
                                    </>
                                }     

                                {
                                    isAdminOperation(auth.data.role) && 
                                    <>
                                        <Route path={`${path}/usuarios`}><UsuarioIndex /></Route>
                                        <Route path={`${path}/roles`}><RolesIndex /></Route>
                                    </>
                                }  

                                {
                                    isCalidad(auth.data.role) && 
                                    <>
                                        <Route path={`${path}/trazabilidad`}><TrazabilidadIndex /></Route>
                                        <Route path={`${path}/reportes-calidad`}><ReportesCalidad /></Route>
                                    </>
                                }

                                {
                                    isConsultorio(auth.data.role) &&
                                    <>
                                        <Route path={`${path}/perfilDoctor`}><PerfilDoctorIndex /></Route>
                                        <Route path={`${path}/create-appointment/:id`}><CreateAppointment /></Route>
                                        <Route path={`${path}/doctors/patients`}><DoctorPacientes perfil="doctor" /></Route>
                                        <Route path={`${path}/doctor/patient/:id`}><EditFormPacientes /></Route>
                                        <Route path={`${path}/doctor/mi-agenda`}><DoctorMiAgenda /></Route>
                                        <Route path={`${path}/proveedor/historial-citas`}><HisorialCitas /></Route>
                                        <Route path={`${path}/proveedor/conferencia/:idParam`}><DoctorConference /></Route>
                                        <Route path={`${path}/proveedor/citas/:idDoctor/:idPaciente`}><CitasPaciente/></Route>
                                        <Route path={`${path}/proveedor/editar-cita/:idCita`}><DoctorEditarCita /></Route>
                                        <Route path={`${path}/proveedor/citacliente/:idParam`}><DoctorConferenceOndemand /></Route>
                                        <Route exact path={`/admin/patients/misrespuestas/:id`}>
                                            <Container fluid className="my-5">
                                                <MisRespuestaUsuario />
                                            </Container>
                                        </Route>
                                        <Route exact path={`/admin/patients/trazabilidad/:id`}>
                                            <Container fluid className="my-5">
                                                <Trazabilidad paciente={true}/>
                                            </Container>                                            
                                        </Route>
                                        <Route exact path={`/admin/patients/create`}>
                                            <Container fluid className="my-5">
                                                <AddPatient/>
                                            </Container>
                                        </Route>
                                    </>
                                }
                                                        
                                <Route path={`${path}/doctor/search/:idPaciente`}><SearchDoctor /></Route> 
                                {/* <Route path="/specialties"><EspecialidadesIndex /></Route> */}
                                <Route path="*"><NoMatch url={url}/></Route>
                            </Switch>
                        </main>
                    </div>
                </div>
            </div>
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={true}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss={false}
                draggable
                pauseOnHover
            />
            
        </>
    )
}

export default withTranslation()(Dashboard)